export const AppConfig = {
  httpTimeout: 90000,
  generalMessageTimeout: 90000
};

export const UrlWhereToShowLoginMenus = [
  '/home', '/reset-password'
];

export const ExcludeUrlAutoLogin = [
  'mobile'
];

export type FirebaseEventName =
|"login"
|"logout"
|"register_from_home"
|"register_from_login"
|"attempt_register"
|"complete_register"
|"first_login"
|"home_play"
|"home_apple"
|"app_home_play"
|"app_home_apple"
|"start_map"
|"change_password_request"
|"change_password_complete"
|"member_accumulate_points"
|"member_register_card"
|"member_loy_bnf_platillo"
|"member_loy_bnf_promocion"
|"member_loy_bnf_experiencia"
|"member_edit_data"
|"member_edit_password"
|"member_cancel_membership"
|"registrer_first_form_complete"
|"registrer_tyc"
|"register_first_form_validated"
|"register_valid_nip"
|"register_resend_nip_sms"
|"register_close_phone_confirm_alert"
|"register_postal_code"
|"register_gender"
|"register_validate_reward_card"
|"register_validate_referral_code"
|"register_validate_employee"
|"register_send_activation_code"
|"register_return_to_register_one"
|"register_send_activation_sms"
|"store_qr"

export const SurveysBannerBrand = [
  '/satisfaction-survey'
]

export const FirebaseEvents: Record<FirebaseEventName, string> = {
  login: 'web_login',
  logout: 'web_logout',
  register_from_home: 'WEB_REGISTRO_INICIAR_FLUJO_HOME',
  register_from_login: 'WEB_REGISTRO_INICIAR_FLUJO_LOGIN',
  attempt_register: 'WEB_REGISTRO_SOLICITAR_ACTIVACION_CUENTA',
  complete_register: 'WEB_REGISTRO_COMPLETADO',
  first_login: 'web_first_login',
  home_play: 'web_home_play_store_app',
  home_apple: 'web_home_apple_store_app',
  app_home_play: 'web_home_app_play_store_app',
  app_home_apple: 'web_home_app_apple_store_app',
  start_map: 'web_locations_start_map',
  change_password_request: 'web_request_change_password',
  change_password_complete: 'web_change_user_password',
  member_accumulate_points: 'web_member_accumulate_points',
  member_register_card: 'web_member_register_card',
  member_loy_bnf_platillo: 'web_member_redeem_dish',
  member_loy_bnf_promocion: 'web_member_redeem_promotion',
  member_loy_bnf_experiencia: 'web_member_redeem_experience',
  member_edit_data: 'web_member_edit_user_info',
  member_edit_password: 'web_member_edit_user_password',
  member_cancel_membership: 'web_member_cancel_membership',
  registrer_first_form_complete: 'WEB_REGISTRO_CAMPOS_OBL_COMPLETADOS',
  registrer_tyc: 'WEB_REGISTRO_TYC_ACEPTADOS',
  register_first_form_validated: 'WEB_REGISTRO_PRIMER_FORMULARIO_VALIDADO',
  register_valid_nip: 'WEB_REGISTRO_NIP_TELEFONO_VALIDADO',
  register_resend_nip_sms: 'WEB_REGISTRO_ENVIAR_NIP_TELEFONO',
  register_close_phone_confirm_alert: 'WEB_REGISTRO_CERRAR_MENSAJE_TELEFONO',
  register_postal_code: 'WEB_REGISTRO_INGRESAR_CODIGO_POSTAL',
  register_gender: 'WEB_REGISTRO_INGRESAR_GENERO',
  register_validate_reward_card: 'WEB_REGISTRO_VALIDAR_REGISTRO_TARJETA',
  register_validate_referral_code: 'WEB_REGISTRO_VALIDAR_CODIGO_REFERIDO',
  register_validate_employee: 'WEB_REGISTRO_VALIDAR_EMPLEADO',
  register_send_activation_code: 'WEB_REGISTRO_VERIFICAR_CODIGO_ACTIVACION',
  register_return_to_register_one: 'WEB_REGISTRO_REGRESAR_A_VALIDAR_INFO',
  register_send_activation_sms: 'WEB_REGISTRO_ENVIO_CODIGO_ACTIVACION_SMS',
  store_qr: 'WEB_QR_ESCANEADO_{marca}_{canal}'
};

export const SmsDefaultTimer = 30;

export enum ShowModalIn {
  Register = 1,
  EditAccount = 2
}

export enum HomeFragments {
  MAIN = 'main',
  BENEFITS = 'benefits',
  EXPERIENCE = 'experience',
  EXCHANGE = 'exchange',
  OFFERS = 'offers',
  HOWITWORKS = 'how-it-works',
  INVITE = 'invite',
  PAYCLUB = 'payclub',
  APPHOME = 'app-home',
  DOWNLOAD = 'download',
  LOCATIONS = 'locations'
}
